// extracted by mini-css-extract-plugin
export default {"Reviews_page":"Reviews_Reviews_page__UGgYC","Reviews":"Reviews_Reviews__w6FY3","Review":"Reviews_Review__14nBq"};